import { Icon } from '@eliadmin/core/src/components/nt/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type FormResult = { status: 'success' | 'failed'; message: string } | null;

/**
 * Outcome of an account form next to its button (the design has no result state): the green
 * check-circle line or the error with the warning icon, Body/M. The live region stays mounted while
 * it is empty, so screen readers announce the change.
 */
export function FormResultMessage({
  result,
  className,
}: {
  result: FormResult;
  className?: string;
}) {
  return (
    <div role="status" className={cn('min-w-0', className)}>
      {result ? (
        <p
          className={cn(
            'nt-body-m flex items-start gap-1.5 whitespace-pre-line',
            result.status === 'success' ? 'text-[#0E6A20]' : 'text-[#B42318]',
          )}
        >
          <Icon
            name={result.status === 'success' ? 'check-circle' : 'warning-circle'}
            size={18}
            className={cn(
              'mt-px',
              result.status === 'success' ? 'text-[#127A26]' : 'text-[#D92D20]',
            )}
          />
          {result.message}
        </p>
      ) : null}
    </div>
  );
}
